import copyToClipboard from "./copyToClipboard";

describe("copyToClipboard", () => {
    it("copies text to clipboard", () => {
        const stringToCopy = "justateststring";
        copyToClipboard(stringToCopy).then((result) => expect(result).toBe(true));
    });
});
